// extracted by mini-css-extract-plugin
export default {"header":"header_header__DECP4","logo":"header_logo__RNsp7","buttons":"header_buttons__x-jph"};